exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.offlineformbutton[data-v-15aa782e]{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center\n}\n.offlineformbutton button[data-v-15aa782e]{\n  margin-right: 5px;\n}\n.custom-date-picker[data-v-15aa782e]{\n  width: 262px;\n}\n", ""]);

// exports
